import { focusBlockEnd } from '@blocksuite/affine-shared/commands';
import { isInsideBlockByFlavour } from '@blocksuite/affine-shared/utils';
import {
  translateGroupStr,
  translateSlashItem,
} from '@blocksuite/affine-shared/utils';
import { type SlashMenuConfig } from '@blocksuite/affine-widget-slash-menu';
import { FontIcon } from '@blocksuite/icons/lit';

import { calloutTooltip } from './tooltips';

export const calloutSlashMenuConfig: SlashMenuConfig = {
  items: () => {
    const t = translateSlashItem('Callout', 'Let your words stand out.');
    return [
      {
        name: t.name,
        description: t.description,
        icon: FontIcon(),
        tooltip: {
          figure: calloutTooltip,
          caption: 'Callout',
        },
        searchAlias: ['callout'],
        group: translateGroupStr('0_Basic@9'),
        when: ({ model }) => {
          return !isInsideBlockByFlavour(
            model.store,
            model,
            'affine:edgeless-text'
          );
        },
        action: ({ model, std }) => {
          const { store } = model;
          const parent = store.getParent(model);
          if (!parent) return;

          const index = parent.children.indexOf(model);
          if (index === -1) return;
          const calloutId = store.addBlock(
            'affine:callout',
            {},
            parent,
            index + 1
          );
          if (!calloutId) return;
          const paragraphId = store.addBlock('affine:paragraph', {}, calloutId);
          if (!paragraphId) return;
          std.host.updateComplete
            .then(() => {
              const paragraph = std.view.getBlock(paragraphId);
              if (!paragraph) return;
              std.command.exec(focusBlockEnd, {
                focusBlock: paragraph,
              });
            })
            .catch(console.error);
        },
      },
    ];
  },
};
